import { useEffect, useState } from "react";
import useGlobals from "@/utils/hooks/useGlobals";
import SelectMobileLessons from "@/components/agenda/mobile/book-speaking-class/SelectMobileLessons";
import AbsoluteBackground from "@/components/ui/AbsoluteBackground";
import DashboardContentLayout from "@/layouts/DashboardContentLayout.tsx";
import { ScheduleSpeakingClassesEvent } from "@/types";
import MobileConfirmation from "@/components/agenda/mobile/book-speaking-class/MobileConfirmation";

const BookSpeakingClass = () => {
  const { setGlobalState } = useGlobals();
  const [step, setStep] = useState(0);
  const [eventDetails, setEventDetails] = useState<ScheduleSpeakingClassesEvent[] | null>(null)
  // const details = useRef<ScheduleSpeakingClassesEvent[] | null>(null);
  // const details = useRef<ScheduleSpeakingClassesEvent[] | []>([]);

  useEffect(() => {
    setGlobalState("backgroundClass", "bg-light");
  }, [step, eventDetails]);

  const handleConfirm = (details: ScheduleSpeakingClassesEvent[] | null) => {
    setEventDetails(details);
    setStep(1);
  };


  return (
    <DashboardContentLayout className={`p-0 ${step === 0 ? 'md:px-0' : 'md:px-[--page-padding-h-lg]'}`}>
      <AbsoluteBackground className="bg-[--primary200]" />

      <div className="relative flex flex-col h-full">
        {step === 0 ? (
          <SelectMobileLessons onConfirm={handleConfirm} />
        ) : (
          <MobileConfirmation events={eventDetails as never} />
        )}
      </div>
    </DashboardContentLayout>
  );
};

export default BookSpeakingClass;